module.exports = __webpack_public_path__ + "static/media/star-3.ebd8aea9.svg";